/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonBlue from "../../components/Button/ButtonBlue";
import {
  hideSharepost,
  showShareto,
  fillList,
  emptyList,
} from "../../redux/actions/sharePost";

import Cancel from "../../common/images/cancel.png";
import "../../styles/shared.styles.scss";
import SharePostCard from "./SharePostCard";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import { list } from "postcss";
import { getGroupFeed } from "../../redux/actions/userReflection";
import Swal from "sweetalert2";
import { ButtonCommonTopNew } from "../Theme";
import { FaSearch } from "react-icons/fa";

function GroupModalShare({ groupId, show, setShow, getGroupPost = null }) {
  const dispatch = useDispatch();
  const [List, setList] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [myPosts, setMyPosts] = useState([]);
  const [textFilter, setTextFilter] = useState("");
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    axios.get(serverUrl.Reflections).then((resp) => {
      if (resp.status === 200) {
        setMyPosts(resp.data.results);
      }
    });
  }, []);

  useEffect(() => {
    if (show) {
      setList([]);
      let temp = [];
      let newList = temp.concat(parseInt(groupId));
      setGroupList(newList);
    }
  }, [show]);

  useEffect(() => {
    const filteredData = myPosts.filter((postItem) =>
      postItem.reflection_title.toLowerCase().includes(textFilter.toLowerCase())
    );

    setFilteredPosts(filteredData);
  }, [textFilter, myPosts]);

  function addItem(id) {
    setList((prev) => {
      const exists = prev.some((p) => p.reflection_id === id);
      if (exists) {
        // remove
        const updated = prev.filter((p) => p.reflection_id !== id);
        return updated;
      } else {
        // add
        const newItems = myPosts.filter((item) => item.reflection_id === id);
        const updated = [...prev, ...newItems];
        return updated;
      }
    });
  }

  function removeItem(id) {
    const newList = List.filter((item) => item.reflection_id !== id);
    setList(newList);
  }

  function close() {
    setShow(false);
  }

  function share() {
    // dispatch(showShareto())
    dispatch(fillList(List));
    axios
      .post(serverUrl.Community, {
        groups: groupList,
        posts: List.map((post) => post.reflection_id),
      })
      .then((resp) => {
        if (resp.status === 200) {
          if (getGroupPost) {
            getGroupPost(groupId);
          } else {
            dispatch(getGroupFeed(groupId));
          }
          Swal.fire(
            "Success",
            "You have shared your post" + (List.length > 1 ? "s." : "."),
            "success"
          );
          close();
        } else if (resp.status === 204) {
          Swal.fire(
            "Duplicate post",
            "You have shared the content to the group",
            "error"
          );
        }
      });

    setShow(false);
  }

  return (
    show && (
      <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
        <div
          className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-extra-width`}
        >
          <div className="flex gap-2 items-center justify-between pb-2">
            <p className="font-semibold blackColor">Share Post</p>
            <button
              onClick={close}
              className="text-gray-600 hover:text-black text-xl font-bold"
            >
              &times;
            </button>
          </div>
          <div className="flex flex-row items-center relative">
            <input
              className="h-9 w-full text-sm bg-white borderf-1 px-2 pr-9 lg:pr-9 blackColor rounded-md"
              type="search"
              placeholder="Type to Search..."
              onChange={(e) => setTextFilter(e.target.value)}
              value={textFilter}
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
              <FaSearch className="secondaryIcon" />
            </div>
          </div>
          <div className="overflow-y-scroll sharepost flex flex-col my-3 gap-3 pr-4">
            {filteredPosts.map((item, idx) => (
              <SharePostCard
                key={idx}
                item={item}
                idx={idx}
                add={addItem}
                remove={removeItem}
              />
            ))}
          </div>
          <div className="w-full flex justify-center">
            <ButtonCommonTopNew
              title=""
              className={`px-5 border p-2 flex gap-2 items-center text-sm rounded-lg ${
                List.length <= 0 ? "pointer-events-none" : "cursor-pointer"
              }`}
              onClick={List.length > 0 ? share : null}
            >
              Share
            </ButtonCommonTopNew>
          </div>
        </div>
      </div>
    )
  );
}

export default GroupModalShare;
